module.exports = "/images/TXR Preview_pages-2.jpg?5f6b13a6d729fd278632bfb7ee8d3ce4";